import { Link } from '@tanstack/react-router';

import { m } from '@/paraglide/messages';

/**
 * Shown when a page fails in the browser. The site is static, so this is its only error page:
 * the host serves its own for platform failures and cannot be given a custom 500.
 */
export function ErrorPage() {
  return (
    <section className='mx-auto max-w-190 px-5 pt-24 pb-28 text-center sm:px-8 sm:pt-30 sm:pb-36'>
      <p className='mb-4 font-bold text-brand'>{m.error_label()}</p>
      <h1 className='mb-5 text-[clamp(38px,5vw,60px)] leading-[1.05] font-bold tracking-[-0.02em]'>
        {m.error_title()}
      </h1>
      <p className='text-body mx-auto mb-9 max-w-130 text-[19px] leading-relaxed'>{m.error_text()}</p>
      <div className='flex flex-wrap justify-center gap-3'>
        <button
          type='button'
          onClick={() => window.location.reload()}
          className='inline-flex min-h-12 items-center justify-center gap-2.5 rounded-full bg-brand px-7 font-semibold text-white transition-colors hover:bg-[#1f4f8a]'
        >
          {m.error_reload()}
        </button>
        <Link
          to='/contact'
          className='inline-flex min-h-12 items-center justify-center gap-2.5 rounded-full border border-[#cfd7e2] bg-white px-7 font-semibold transition-colors hover:border-brand hover:text-brand'
        >
          {m.error_contact()}
        </Link>
      </div>
    </section>
  );
}
